export const SAVED_PLACES_COLUMN_ID = 'saved-places';
